import React, { useState, useEffect } from "react";
import LoginTile from "./LoginTile";
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";


function PageHeader() {

  const [userName, setUserName] = useState();
  const [loggedIn, setLoggedIn] = useState(false);


  const [queryText, setQueryText] = useState();

  const onChangeQueryText = (e) => {
    const qText = e.target.value;
    setQueryText(qText);
  };
  const handleSearch = (e) => {
    if (queryText === "") { return; }
    window.location.href = "/SearchResultsList?qry_txt=" + queryText;
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }

  const [showLoginWindow, setShowLoginWindow] = useState(false);

  const handleLoginTileReturn = (sts) => {
    setShowLoginWindow(false);
    if (sts) {
      const user = Cookies.get('username');
      if (user) {
        setUserName(user);
        setLoggedIn(true);
      }
    } else {
      setLoggedIn(false);
    }
  }


  const [showUserMenu, setShowUserMenu] = useState(false);


  const handleLogout = (e) => {
    setLoggedIn(false);
    axios.get("/api/v1/auth/checkCookies")
      .then((result) => { })
      .catch((err) => console.log(err));

    axios
      .get("/api/v1/auth/logout")
      .then((result) => {
        window.location.href = "/Logout";
      })
      .catch((err) => alert("Logout Failed!!!"));
  }

  useEffect(() => {
    const user = Cookies.get('username');
    if (user) {
      setUserName(user);
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [])
  return (
    <div>
      <div className="page-header">
        <div className="logo-container">
          <Link to="/">
            <img
              src="/graphics/RedSaysBlueSaysLogo.png"
              width="230px"
              alt="RedSaysBlueSays.com"
            />
          </Link>
        </div>
        <div>
          <input name="name" type="text" size="30" placeholder="Search" required onChange={onChangeQueryText} onKeyDown={handleKeyDown} />
          <img src="/graphics/icons/search.svg" onClick={handleSearch} alt="search" style={{ cursor: 'pointer' }} />
        </div>
        <div className="header-link">
          {loggedIn ?
            <div className="custom-link" onClick={() => setShowUserMenu(true)}>{userName}</div>
            :
            <div className="custom-link" onClick={() => setShowLoginWindow(true)}>Login</div>
          }
        </div>
        {showUserMenu && (
          <div className="overlay">
            <div className="popup">
              <h3>User Menu</h3>
              <div className="header-link">
                <div><Link to="/UserPreferences">Preferences</Link></div>
                <div><Link to="/">Profile</Link></div>
                <div className="custom-link" onClick={() => handleLogout()}>Logout</div>
                <div><Link to="/WhereDoILean.html">Find My Party</Link></div>
                <br />
                <button onClick={() => setShowUserMenu(false)}>Cancel</button>

              </div>
            </div>
          </div>

        )}
        {showLoginWindow && (
          <LoginTile sendValueBack={handleLoginTileReturn} />
        )}

      </div>
    </div>
  );
}

export default PageHeader;
